export default class PdfNumber extends Number {
  constructor(value: number) {
    super(value);
  }

  toString(): string {
    return `${this.valueOf()}`;
  }
}
